import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import bold from "../assets/bold.png"
import italic from "../assets/italic.png"
import gallery from "../assets/gallery.png"
import gif from "../assets/gif.png"
import emijo from "../assets/emijo.png"
import location from "../assets/location.png"
import edit from "../assets/edit (2).png"
import share from "../assets/link.png"
import time from "../assets/time.png"
import del from "../assets/delete.png"
import user from "../assets/user.png"
import feed from "../assets/feed.png"
import like from "../assets/blike.png"
import link from "../assets/barrow.png"
import dot from "../assets/dot.png"
import one from "../assets/one.png"
import two from "../assets/two.png"
import three from "../assets/three.png"
import four from "../assets/four.png"
import plus from "../assets/plus.png"
import { useNavigate } from 'react-router-dom'
import Feeddropdown from './Feeddropdown'
import u1 from "../assets/u1.png"
import u2 from "../assets/u2.png"
import u3 from "../assets/u3.png"
import u4 from "../assets/u4.png"
import p1 from "../assets/p1.png"
import p2 from "../assets/p2.png"
import p3 from "../assets/p3.png"
import p4 from "../assets/p4.png"
import p5 from "../assets/p5.png"

function Myfeed() {
    const Navigate = useNavigate()
    const createpost = () => {
        Navigate("/posting")
    }
    const addaccount = () => {
        Navigate("/add")
    }
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
          
                <div className='inner_div mb-4  pt-2 ps-2 pe-2 pb-4 w-100' style={{ backgroundColor: "white", marginTop: "85px" }}>
                    <div className='main_fee'>
                        <div className='main_fee1 '>
                            <p className='post_heading text-center mt-3'>Quick Post</p>
                            <div className='post_div' style={{ boxShadow: "none", border: "1px solid rgba(188, 188, 188, 1)" }}>
                                <div className='descriptiondiv' style={{ border: "none", paddingBottom: "0px" }}>
                                    <textarea placeholder='Description...' className='description_input mt-2' />
                                    <div className='d-flex justify-content-between align-items-end pe-2'>
                                        <div className='description_emijo'>
                                            <img className='img_description' src={bold} />
                                            <img className='img_description' src={italic} />
                                            <img className='img_description' src={gallery} />
                                            <img className='img_description' src={gif} />
                                            <img className='img_description' src={emijo} />
                                            <img className='img_description' src={location} />
                                            <img src={edit} />
                                            <img src={share} />
                                            <img src={del} />
                                            <img src={time} />
                                        </div>
                                    </div>
                                    <button className='ad_btn mt-3 mb-0' style={{ maxWidth: "100%" }}>Publish</button>
                                </div>
                            </div>
                            <div className='create_post_div'>
                                <p className='post_heading ' style={{ textAlign: "center", paddingTop: "20px" }}>My Accounts</p>
                                <div className='user_social'>
                                    <img src={one} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={two} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={three} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={four} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='button_div'>
                                    <button className='post_btn' onClick={createpost}>Create Post</button>
                                    <button className='Add_Account' onClick={addaccount}>
                                        <div className='d-flex align-items-center gap-2 flex-wrap justify-content-center'>
                                            <img src={plus} />
                                            <p className='account_text'>Add Account</p>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className=' w-100'>
                            <p className='feed_heading'>My Feed</p>
                            <div className='mb-3'>
                                <Feeddropdown />
                            </div>
                            {/* <div className='main_badges d-flex gap-2 justify-content-between flex-wrap mt-2'>
                                <div className=' '>
                                    <div className='feed_border'>
                                        <p>Twitter</p>
                                    </div>
                                </div>
                                <div className=' '>
                                    <div className='feed_border'>
                                        <p>Instagram</p>
                                    </div>
                                </div>
                                <div className=' '>
                                    <div className='feed_border'>
                                        <p>Facebook</p>
                                    </div>
                                </div>
                            </div> */}
                            <div className='d-flex gap-2 flex-wrap justify-content-between main_fee2'>
                                <div className=' badge1'>
                                    <div className='feed_border' style={{ borderBottom: "1px solid rgba(188, 188, 188, 0.3)", borderTop: "1px solid rgba(188, 188, 188, 0.3)", paddingTop: "10px" }}>
                                        <p>Twitter</p>
                                    </div>
                                    <div className='user_card ps-2 pe-2 '>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <img className='user_img' src={user} />
                                            <div>
                                                <p className='user_name'>Adam Person</p>
                                                <p className="feed_time">7 min ago</p>
                                            </div>
                                        </div>
                                        <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                                            tur. Malesuada sagittis ac ipsum eu
                                            morbi ut aliquet.<span className='text_span'> @samuel</span> consecte.</p>
                                        <p className='feed_more'>... See more</p>
                                        <img className='w-100 mb-2' src={p1} />
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='d-flex gap-1'>
                                                    <img className='like' src={like} />
                                                    <p className='likes' style={{ color: "rgba(45, 156, 219, 1)" }}>1k</p>
                                                </div>
                                                <img className='link' src={link} />
                                            </div>
                                            <div className='d-flex gap-1'>
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='user_card ps-2 pe-2 '>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <img className='user_img' src={u1} />
                                            <div>
                                                <p className='user_name'>Adam Person</p>
                                                <p className="feed_time">7 min ago</p>
                                            </div>
                                        </div>
                                        <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                                            tur. Malesuada sagittis ac ipsum eu
                                            morbi ut aliquet.<span className='text_span'> @samuel</span> consecte.</p>
                                        <p className='feed_more'>... See more</p>
                                        <img className='w-100 mb-2' src={p2} />
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='d-flex gap-1'>
                                                    <img className='like' src={like} />
                                                    <p className='likes' style={{ color: "rgba(45, 156, 219, 1)" }}>1k</p>
                                                </div>
                                                <img className='link' src={link} />
                                            </div>
                                            <div className='d-flex gap-1'>
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className=' badge2'>
                                    <div className='feed_border' style={{ borderBottom: "1px solid rgba(188, 188, 188, 0.3)", borderTop: "1px solid rgba(188, 188, 188, 0.3)", paddingTop: "10px" }}>
                                        <p>Instagram</p>
                                    </div>
                                    <div className='user_card ps-2 pe-2 '>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <img className='user_img' src={p3} />
                                            <div>
                                                <p className='user_name'>Adam Person</p>
                                                <p className="feed_time">7 min ago</p>
                                            </div>
                                        </div>
                                        <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                                            tur. Malesuada sagittis ac ipsum eu
                                            morbi ut aliquet.<span className='text_span'> @samuel</span> consecte.</p>
                                        <p className='feed_more'>... See more</p>
                                        <img className='w-100 mb-2' src={feed} />
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='d-flex gap-1'>
                                                    <img className='like' src={like} />
                                                    <p className='likes' style={{ color: "rgba(45, 156, 219, 1)" }}>1k</p>
                                                </div>
                                                <img className='link' src={link} />
                                            </div>
                                            <div className='d-flex gap-1'>
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='user_card ps-2 pe-2 '>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <img className='user_img' src={u3} />
                                            <div>
                                                <p className='user_name'>Adam Person</p>
                                                <p className="feed_time">7 min ago</p>
                                            </div>
                                        </div>
                                        <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                                            tur. Malesuada sagittis ac ipsum eu
                                            morbi ut aliquet.<span className='text_span'> @samuel</span> consecte.</p>
                                        <p className='feed_more'>... See more</p>
                                        <img className='w-100 mb-2' src={feed} />
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='d-flex gap-1'>
                                                    <img className='like' src={like} />
                                                    <p className='likes' style={{ color: "rgba(45, 156, 219, 1)" }}>1k</p>
                                                </div>
                                                <img className='link' src={link} />
                                            </div>
                                            <div className='d-flex gap-1'>
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='badge3'>
                                <div className='feed_border' style={{ borderBottom: "1px solid rgba(188, 188, 188, 0.3)", borderTop: "1px solid rgba(188, 188, 188, 0.3)", paddingTop: "10px" }}>
                                        <p>Facebook</p>
                                    </div>
                                    <div className='user_card pt-2 ps-2 pe-2  '>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <img className='user_img' src={u4} />
                                            <div>
                                                <p className='user_name'>Adam Person</p>
                                                <p className="feed_time">7 min ago</p>
                                            </div>
                                        </div>
                                        <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                                            tur. Malesuada sagittis ac ipsum eu
                                            morbi ut aliquet.<span className='text_span'> @samuel</span> consecte.</p>
                                        <p className='feed_more'>... See more</p>
                                        <img className='w-100 mb-2' src={p4} />
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='d-flex gap-1'>
                                                    <img className='like' src={like} />
                                                    <p className='likes' style={{ color: "rgba(45, 156, 219, 1)" }}>1k</p>
                                                </div>
                                                <img className='link' src={link} />
                                            </div>
                                            <div className='d-flex gap-1'>
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='user_card ps-2 pe-2 '>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <img className='user_img' src={user} />
                                            <div>
                                                <p className='user_name'>Adam Person</p>
                                                <p className="feed_time">7 min ago</p>
                                            </div>
                                        </div>
                                        <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                                            tur. Malesuada sagittis ac ipsum eu
                                            morbi ut aliquet.<span className='text_span'> @samuel</span> consecte.</p>
                                        <p className='feed_more'>... See more</p>
                                        <img className='w-100 mb-2' src={feed} />
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='d-flex gap-1'>
                                                    <img className='like' src={like} />
                                                    <p className='likes' style={{ color: "rgba(45, 156, 219, 1)" }}>1k</p>
                                                </div>
                                                <img className='link' src={link} />
                                            </div>
                                            <div className='d-flex gap-1'>
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                                <img className='dot' src={dot} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>





    </>

    )
}

export default Myfeed